import { defineComponent } from "vue";

/**
 * 渲染 `Record` SVG 图标。
 *
 * @remarks
 * Vue 透传属性（如 `class`、`style`、`role`、`aria-label`、`width`、`height` 和 `fill`）会应用到根 `<svg>` 元素。
 */
export const Record = defineComponent({
	name: "Record",
	render() {
		return (
			<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1024 1024">
				<path d="M324.266667 136.533333a34.133333 34.133333 0 0 1 2.56 68.181334L324.266667 204.8h-119.466667v682.666667h614.4V204.8h-110.933333a34.133333 34.133333 0 0 1-2.56-68.181333L708.266667 136.533333H819.2a68.266667 68.266667 0 0 1 68.181333 64.853334L887.466667 204.8v682.666667a68.266667 68.266667 0 0 1-64.853334 68.181333L819.2 955.733333H204.8a68.266667 68.266667 0 0 1-68.181333-64.853333L136.533333 887.466667V204.8a68.266667 68.266667 0 0 1 64.853334-68.181333L204.8 136.533333h119.466667z"></path>
				<path d="M631.466667 68.266667H392.533333c-56.405333 0-102.4 45.994667-102.4 102.4s45.994667 102.4 102.4 102.4h238.933334c56.405333 0 102.4-45.994667 102.4-102.4s-45.994667-102.4-102.4-102.4zM392.533333 136.533333h238.933334c18.688 0 34.133333 15.445333 34.133333 34.133334s-15.445333 34.133333-34.133333 34.133333H392.533333c-18.688 0-34.133333-15.445333-34.133333-34.133333s15.445333-34.133333 34.133333-34.133334z"></path>
				<path d="M496.7936 358.4c104.704 0 189.576533 84.872533 189.576533 189.576533 0 40.021333-12.407467 77.141333-33.570133 107.741867l71.0656 71.0656-48.264533 48.2816-71.0656-71.082667a188.706133 188.706133 0 0 1-107.741867 33.570134C392.0896 737.553067 307.2 652.680533 307.2 547.976533 307.2 443.272533 392.0896 358.4 496.7936 358.4z m0 68.266667a121.309867 121.309867 0 1 0-0.017067 242.6368A121.309867 121.309867 0 0 0 496.7936 426.666667z"></path>
			</svg>
		);
	},
});

export default Record;
